(function() {
  function initColorGallery() {
    const gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    const carousel = gallery.querySelector('media-carousel');
    if (!carousel) return;

    const allMediaItems = Array.from(carousel.querySelectorAll('.product-gallery__media'));
    const allThumbnails = Array.from(gallery.querySelectorAll('.product-gallery__thumbnail'));

    // Get all color names from the variant picker radio inputs
    const colorInputs = Array.from(document.querySelectorAll('variant-picker input[type="radio"][name="option1"]'));
    if (!colorInputs.length) return;

    // Get unique color names that have matching alt-text images
    const colorNames = [...new Set(colorInputs.map(i => i.value.toLowerCase()))];
    const hasColorImages = colorNames.some(color =>
      allMediaItems.some(item => {
        const img = item.querySelector('img');
        return img && img.alt.toLowerCase() === color;
      })
    );
    if (!hasColorImages) return;

    function switchColor(colorName) {
      const color = colorName.toLowerCase();
      let firstVisibleIndex = -1;

      allMediaItems.forEach((item, index) => {
        const img = item.querySelector('img');
        const altColor = img ? img.alt.toLowerCase() : '';

        // Show if alt matches selected color, or if image has no color alt (shared images)
        const isColorTagged = colorNames.some(c => altColor === c);
        const matches = !isColorTagged || altColor === color;

        item.hidden = !matches;
        if (matches && firstVisibleIndex === -1) firstVisibleIndex = index;
      });

      allThumbnails.forEach((thumb, index) => {
        const item = allMediaItems[index];
        if (item) thumb.hidden = item.hidden;
      });

      // Scroll carousel to first visible image for this color
      if (firstVisibleIndex !== -1) {
        carousel.select(firstVisibleIndex, { animate: false });
      }
    }

    // Listen for radio change on color option
    document.querySelector('variant-picker')?.addEventListener('change', (e) => {
      if (e.target.name === 'option1' && e.target.checked) {
        switchColor(e.target.value);
      }
    });

    // Run on page load with the initially selected color
    const selected = colorInputs.find(i => i.checked);
    if (selected) switchColor(selected.value);
  }

  function tryInit() {
    const gallery = document.querySelector('product-gallery');
    const picker = document.querySelector('variant-picker');
    // Check that both elements are in the DOM and the carousel has rendered its items
    if (gallery && picker && gallery.querySelector('.product-gallery__media')) {
      initColorGallery();
    } else {
      setTimeout(tryInit, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();

(()=>{"use strict";var t,e={772:(t,e,n)=>{var r=n(91),o=function(){var t=this,e=t._self._c;return e("button",{staticClass:"button",attrs:{type:"submit",disabled:t.isLoading}},[t.isLoading?e("span",{staticClass:"spinner"},[t._v(t._s(t.loadingLabel))]):t._t("default")],2)};o._withStripped=!0;const i={props:{isLoading:{type:Boolean,required:!0},loadingLabel:{type:String,default:"Loading"}}};const a=(0,n(327).A)(i,o,[],!1,null,null,null).exports;r.Ay.component("ButtonSpinner",a);var s=function(){return document.querySelectorAll("[vue-init]").forEach((function(t){!function(t){new r.Ay({el:t,delimiters:["${","}"],components:{}})}(t)}))};s(),document.addEventListener("shopify:section:load",(function(t){t.target.id.includes("megamenu")||s()}))}},n={};function r(t){var o=n[t];if(void 0!==o)return o.exports;var i=n[t]={exports:{}};return e[t](i,i.exports,r),i.exports}r.m=e,t=[],r.O=(e,n,o,i)=>{if(!n){var a=1/0;for(c=0;c<t.length;c++){for(var[n,o,i]=t[c],s=!0,l=0;l<n.length;l++)(!1&i||a>=i)&&Object.keys(r.O).every((t=>r.O[t](n[l])))?n.splice(l--,1):(s=!1,i<a&&(a=i));if(s){t.splice(c--,1);var u=o();void 0!==u&&(e=u)}}return e}i=i||0;for(var c=t.length;c>0&&t[c-1][2]>i;c--)t[c]=t[c-1];t[c]=[n,o,i]},r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"==typeof window)return window}}(),r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),(()=>{var t={386:0};r.O.j=e=>0===t[e];var e=(e,n)=>{var o,i,[a,s,l]=n,u=0;if(a.some((e=>0!==t[e]))){for(o in s)r.o(s,o)&&(r.m[o]=s[o]);if(l)var c=l(r)}for(e&&e(n);u<a.length;u++)i=a[u],r.o(t,i)&&t[i]&&t[i][0](),t[i]=0;return r.O(c)},n=self.webpackChunkastro=self.webpackChunkastro||[];n.forEach(e.bind(null,0)),n.push=e.bind(null,n.push.bind(n))})();var o=r.O(void 0,[845],(()=>r(772)));o=r.O(o)})();